export const PRACTITIONER_APPLICATION_DROPDOWN_MAX_WIDTH = 440;

export const practitionerApplicationDropdownWrapperProps = {
  width: "100%",
  maxWidth: PRACTITIONER_APPLICATION_DROPDOWN_MAX_WIDTH
};

export const practitionerApplicationDropdownButtonSx = {
  border: "2px solid",
  borderColor: "#E5E5E5",
  color: "midGrey"
};
